import { BASE_PATH, BASE_PATH_EXTENSION_ADMIN } from "../../utils/constants";
import { getToken } from "../Auth/token";
import axios from "axios";

const baseUrl = `${BASE_PATH}${BASE_PATH_EXTENSION_ADMIN}/media`;

export function apiList(data) {
    const config = { headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}` } };
    return axios.get(`${baseUrl}/list?limit=${data.limit}&offset=${data.offset}`, config)
}

export function apiUpload(data) {
    const config = { headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}` } };
    return axios.post(`${baseUrl}/save`, data, config)
}

export function apiDelete(id) {
    const config = { headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}` } };
    return axios.delete(`${baseUrl}/delete?id=${id}`, config)
}

export function apiGetMedia(relativePath) {
    const config = { headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}` } };
    return axios.get(`${baseUrl}/get?relative_path=${encodeURIComponent(relativePath)}`, config);
}

export function apiGetMediaVerifactur(relativePath) {
    const config = { headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}` } };
    return axios.get(`${baseUrl}/get-verifactur?relative_path=${encodeURIComponent(relativePath)}`, config);
}

export function apiGetMediaElement(relativePath) {
    const config = { headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}` } };
    return axios.get(`${baseUrl}/get-element?relative_path=${encodeURIComponent(relativePath)}`, config);
}